import {
  IonContent,
  IonPage,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { playOutline, trophyOutline, settingsOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage>
      <IonContent fullscreen className="home-content">
        <div className="home-container">
          <div className="logo-area">
            <div className="logo-mouse" aria-hidden="true">
              <svg viewBox="0 0 80 80" width="80" height="80">
                <circle cx="40" cy="42" r="28" fill="#b8b0a0" />
                <circle cx="24" cy="18" r="14" fill="#f0a0b0" />
                <circle cx="56" cy="18" r="14" fill="#f0a0b0" />
                <circle cx="32" cy="36" r="5" fill="#222" />
                <circle cx="48" cy="36" r="5" fill="#222" />
                <ellipse cx="40" cy="48" rx="6" ry="4" fill="#f0a0b0" />
                <path d="M12 42 Q0 38 4 50" stroke="#b8b0a0" strokeWidth="3" fill="none" />
              </svg>
            </div>
            <h1 className="game-title">ChompChomp</h1>
            <p className="game-subtitle">Help Chomp the Mouse eat all the cheese!</p>
          </div>

          <div className="menu-buttons">
            <IonButton
              expand="block"
              size="large"
              color="primary"
              className="menu-btn play-btn"
              onClick={() => history.push('/game')}
            >
              <IonIcon slot="start" icon={playOutline} />
              Play
            </IonButton>

            <IonButton
              expand="block"
              size="large"
              color="secondary"
              className="menu-btn"
              onClick={() => history.push('/leaderboard')}
            >
              <IonIcon slot="start" icon={trophyOutline} />
              Leaderboard
            </IonButton>

            <IonButton
              expand="block"
              size="large"
              color="tertiary"
              className="menu-btn"
              onClick={() => history.push('/settings')}
            >
              <IonIcon slot="start" icon={settingsOutline} />
              Settings
            </IonButton>
          </div>

          <div className="home-cats" aria-hidden="true">
            <span className="cat-emoji">🐱</span>
            <span className="cat-emoji">🐈‍⬛</span>
            <span className="cat-emoji">🐱</span>
            <span className="cat-emoji">🐈</span>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
